module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.dataRequiredLoaded) ? _c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [(_vm.isGgv) ? _c('div', {
    staticClass: "bg-warning lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3 text-black"
  }, [_c('strong', [_vm._v("GGV")]), _c('br'), _vm._v("\n                  Você está fazendo a vistoria para guarda deste veículo\n                ")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', [_c('form', {
    staticClass: "bs-example form-horizontal form-grv",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar a GRV, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Atualizado com sucesso!")])]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('div', {
    staticClass: "col-sm-12 col-xs-12 m-b"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default wrapper-sm m-b"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.numero))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Apreensão")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.extraModel.dataApreensao) + " " + _vm._s(_vm.extraModel.horaApreensao))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Placa Original")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.placaOriginal || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Placa Ostentada")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.placa || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chassi")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.chassi || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Marca")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.marca || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.modelo || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cor")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.cor || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Renavam")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.renavam || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ano")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.ano || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número do Motor")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.numeroMotor || '-'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataEntradaPatio"
    }
  }, [_vm._v("Data/Hora GGV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/#### ##:##'),
      expression: "'##/##/#### ##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataEntradaPatio),
      expression: "data.dataEntradaPatio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dataEntradaPatio",
      "type": "text",
      "placeholder": "dd/mm/yyyy hh:mm"
    },
    domProps: {
      "value": (_vm.data.dataEntradaPatio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataEntradaPatio", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "recebedorPatio"
    }
  }, [_vm._v("Recebedor Pátio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.recebedorPatio),
      expression: "data.recebedorPatio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "recebedorPatio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "recebedorPatio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.atendentesPatio), function(atendente) {
    return _c('option', {
      key: atendente.id,
      attrs: {
        "disabled": !atendente.ativo
      },
      domProps: {
        "value": atendente.id
      }
    }, [_vm._v("\n                                    " + _vm._s(atendente.nome) + " "), (!atendente.ativo) ? _c('span', {
      staticStyle: {
        "font-size": "small",
        "color": "red"
      }
    }, [_vm._v("(inativo)")]) : _vm._e()])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "tipoRemocao"
    }
  }, [_vm._v("Tipo GGV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipoGgv),
      expression: "data.tipoGgv"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tipoRemocao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipoGgv", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.tiposGrv), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.id
      }
    }, [_vm._v(_vm._s(tipo.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "matriculaPolicialRecebedorPatio"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policialSelecionado.nome),
      expression: "policialSelecionado.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "nomePolicialRecebedorPatio",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.policialSelecionado.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policialSelecionado, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policialSelecionado.matricula),
      expression: "policialSelecionado.matricula"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "matriculaPolicialRecebedorPatio",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.policialSelecionado.matricula)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policialSelecionado, "matricula", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "estadoVeiculo"
    }
  }, [_vm._v("Estado do veículo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.estadoVeiculo),
      expression: "data.estadoVeiculo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "estadoVeiculo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "estadoVeiculo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.estadosVeiculo), function(estado) {
    return _c('option', {
      domProps: {
        "value": estado.id
      }
    }, [_vm._v(_vm._s(estado.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "unidadePolicial"
    }
  }, [_vm._v("Unidade Policial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.unidadePolicialRecebedorPatio),
      expression: "data.unidadePolicialRecebedorPatio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "unidadePolicial"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "unidadePolicialRecebedorPatio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.unidadesPoliciais), function(unidadePolicial) {
    return _c('option', {
      key: unidadePolicial.id,
      domProps: {
        "value": unidadePolicial.id
      }
    }, [_vm._v("\n                                    " + _vm._s(unidadePolicial.nome) + "\n                                  ")])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "trancado"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.trancado),
      expression: "data.trancado"
    }],
    attrs: {
      "type": "checkbox",
      "id": "trancado",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.trancado) ? _vm._i(_vm.data.trancado, null) > -1 : (_vm.data.trancado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.trancado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "trancado", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "trancado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "trancado", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "trancado"
    }
  }, [_vm._v("Trancado")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "comChave"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.comChave),
      expression: "data.comChave"
    }],
    attrs: {
      "type": "checkbox",
      "id": "comChave",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.comChave) ? _vm._i(_vm.data.comChave, null) > -1 : (_vm.data.comChave)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.comChave,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "comChave", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "comChave", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "comChave", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "comChave"
    }
  }, [_vm._v("Com Chave")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "observacoesGgv"
    }
  }, [_vm._v("Observações GGV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.observacoesGgv),
      expression: "data.observacoesGgv"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "observacoesGgv",
      "rows": "7"
    },
    domProps: {
      "value": (_vm.data.observacoesGgv)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "observacoesGgv", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Equipamentos / Acessórios")]), _vm._v(" "), _vm._l((_vm.dataRequired.equipamentos), function(equip) {
    return _c('div', {
      key: equip.id,
      staticClass: "form-group b-b padder-v"
    }, [_c('div', {
      staticClass: "col-sm-offset-2 col-sm-10"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": equip.id,
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(equip.checked) ? _vm._i(equip.checked, null) > -1 : (equip.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = equip.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(equip, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(equip, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(equip, "checked", $$c)
          }
        }, function($event) {
          return _vm.marcaEquipamento($event, equip)
        }]
      }
    }), _c('i')]), _vm._v(" "), _c('label', {
      attrs: {
        "for": equip.id
      }
    }, [_vm._v(_vm._s(equip.nome))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      staticClass: "col-xs-4 form-inline"
    }, [_c('label', [_vm._v("Avaria: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (equip.avaria),
        expression: "equip.avaria"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(equip, "avaria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.dataRequired.avarias), function(avaria) {
      return _c('option', {
        key: avaria.id,
        domProps: {
          "value": avaria.id
        }
      }, [_vm._v(_vm._s(avaria.nome))])
    })], 2)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "col-xs-4"
    }, [_c('btn-check-possui', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      model: {
        value: (equip.possui),
        callback: function($$v) {
          _vm.$set(equip, "possui", $$v)
        },
        expression: "equip.possui"
      }
    })], 1)])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Fotos")]), _vm._v(" "), _c('arquivos-grv', {
    attrs: {
      "arquivos": _vm.data.arquivosGgv,
      "tipos-arquivo": _vm.dataRequired.tipoArquivo,
      "tipos-arquivo-ocultar": _vm.tiposArquivoOcultar,
      "origem": "ggv"
    }
  })], 1)]), _vm._v(" "), (_vm.isGgv) ? _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h2', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                        Parecer Final\n                      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isGgv) ? _c('div', {
    staticClass: "wrapper-md m-b-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Em conformidade com a GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ggv.conforme),
      expression: "ggv.conforme"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ggv, "conforme", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Conforme")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não conforme")])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isGgv) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-success btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar e adicionar outro(a)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar e continuar editando")]), _vm._v(" "), (_vm.edit) ? _c('button', {
    staticClass: "btn btn-danger btn-md m-l-xs btn-colsultaGrv pull-right"
  }, [_vm._v("Apagar\n                      ")]) : _vm._e()])])]) : _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block btn-lg"
  }, [_vm._v("Confirmar GGV")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("* a confirmação inclui imeditamente este bem no pátio e transmite as\n                        informações para o DETRO\n                      ")])])])])])])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-471ace98","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/roubo-furto/components/Ggv.vue
// module id = 1826
// module chunks = 18